<td *ngFor="let col of columns" [style.height]="col.height || '60px'" (click)="clicked(row, col)">
  <ng-container *ngIf="col.editable && row.editMode; else presentational">
    <form #rowForm [formGroup]="form">
      <mat-form-field appearance="outline">
        <input
          #input
          matInput
          maxlength="{{ col.maxlength }}"
          autocomplete="no-autofill"
          [formControlName]="col.field"
          [placeholder]="col.header | xTranslate"
          value="{{ row | dataCellFormatter: col }}"
          (keyup.enter)="submit()"
          (blur)="submit()"
        />
      </mat-form-field>
      <div *ngIf="col.maxlength">
        <mat-hint>{{ input.value?.length || 0 }}/{{ col.maxlength }}</mat-hint>
      </div>
    </form>
  </ng-container>
  <ng-template #presentational>
    <!-- PRESENTATIONAL CELL -->
    <miq-tableCheckbox [value]="row" *ngIf="col.checkbox" [disabled]="col.disabled"></miq-tableCheckbox>

    <p class="data-row">
      <ng-container *ngIf="col.toggler">
        <ng-container *ngIf="col.toggler.indent">
          <span [miqIndent]="row.level"></span>
        </ng-container>

        <span class="container-icon" *ngIf="row.isContainer">
          <mat-icon
            *ngIf="row.expanded && col.toggler.expand_icon"
            [svgIcon]="col.toggler.expand_icon"
            [style.width]="col.toggler.width || '24px'"
          ></mat-icon>

          <mat-icon
            *ngIf="!row.expanded && col.toggler.expanded_icon"
            [svgIcon]="col.toggler.expanded_icon"
            [style.width]="col.toggler.width || '24px'"
          ></mat-icon>
        </span>
      </ng-container>

      <ng-container *ngIf="!row.isContainer && col.link; else normal">
        <a (click)="col.link.command(row)">{{ col.link.text || row | dataCellFormatter: col }}</a>
      </ng-container>

      <ng-template #normal>{{ row | dataCellFormatter: col }}</ng-template>
    </p>
    <ng-container *ngIf="col.subtitleCellFormater">
      <p class="subtitle-text">
        <ng-container *ngIf="col.toggler && col.toggler.indent"> <span [miqIndent]="row.level"></span> </ng-container
        >{{ row | subtitleCellFormater: col }}
      </p>
    </ng-container>
  </ng-template>
</td>
